import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PasswordValidator } from 'src/app/directives/password-validator.directive';

@Component({
  selector: 'app-enable-authenticator-app-info',
  templateUrl: './enable-authenticator-app-info.component.html'
})
export class EnableAuthenticatorAppInfoComponent implements OnInit {
  @Output('password') password = new EventEmitter<string>();
  @Output('close') closeDialog = new EventEmitter();
  form: UntypedFormGroup;
  passwordControl: FormControl;


  constructor(private formBuilder: UntypedFormBuilder) {
    this.passwordControl = new FormControl('', [Validators.required]);
    this.form = this.formBuilder.group(
      {
        password: this.passwordControl,
      }
    );
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  async checkPassword() {
    this.password.emit(this.passwordControl.value);
  }

  async close(){
    this.closeDialog.emit();
  }

}
